export const CHANNEL_TYPE = Object.freeze({
  MOBILE: "mobile",
  PHONE: "phone",
  EMAIL: "email",
  DEFAULT: "mobile"
});